import React, { Component } from "react";
import PubSub from "pubsub-js";
import { browserHistory } from "react-router";
import "./css/indexPage.less";
import { Layout, Menu, Dropdown, Button, Icon, Modal } from "antd";
import { Card } from "antd";
import Notice from "./Notice";
import TodoList from "./TodoList";
import SysInfos from "./SysInfos";
import DlMenu from "./DlMenu";
import codeImg from "./icon/code.png";
// import mainLogo from "./icon/mk_logo-bl.png";
import mainLogo from "../../login/200x35蒙牛.png";

import { menusForEach } from "../../../routes";
// 引入功能组件
import ModifyPassword from "./operation/ModifyPassword";
import UserInfos from "./operation/UserInfos";
import Logout from "./operation/Logout";
// import Lock from "./operation/Lock";
import MsgList from "./operation/MsgList/index";
import { tool } from "rt-sd-common";

const { Header, Sider, Content, Footer } = Layout;

const menu = (
  // <div></div>
  <Menu>
    <Menu.Item>
      <ModifyPassword></ModifyPassword>
    </Menu.Item>
    {/* <Menu.Item>
      <UserInfos>
        <span>奥术大师大</span>
      </UserInfos>
    </Menu.Item> */}
  </Menu>
);

export default class indexPage extends Component {
  state = {
    navMenus: [], //菜单
  };
  
  componentDidMount() {
    this.getMenuByServer();
  }
  getMenuByStorage() {
    let navMenus = JSON.parse(sessionStorage.getItem("asyncRoutes"));
    if (!navMenus) return this.getMenuByServer();
    this.setState({
      navMenus,
    });
    window.menuByServer = navMenus;
    //创建路由
    menusForEach(navMenus);
    console.log(navMenus);
    PubSub.publish("setRoutes", navMenus);
  }
  // 获取菜单树
  getMenuByServer() {
    var me = this;
    var success = function (res) {
      if (res && res.head.code == "0000") {
        let navMenus = res.body || [];
        // 缓存menu
        let asyncRoutes = JSON.stringify(navMenus);
        sessionStorage.setItem("asyncRoutes", asyncRoutes);

        me.setState({
          navMenus,
        });
        window.menuByServer = navMenus;
        //创建路由
        menusForEach(navMenus);
        PubSub.publish("setRoutes", navMenus);
      }
    };
    commonClient.simplecall(
      sgiConfig.allUrl.userMenus,
      { channelId: "0" },
      success,
      true
    );
  }
  testpub = () => {
    tool.initBreadcrumbArr();
    tool.popSingleUI("/main");
  };
  render() {
    let userName = tool.getCookie("nikNam");
    let hasToken = tool.getCookie("token");
    if(!hasToken) return null
    return (
      <div>
        <Layout className="layout">
          <Sider>
            <div className="mainLogo">
              <img onClick={this.testpub} src={mainLogo}></img>
            </div>
            <div className="menu_outer">
              <DlMenu navMenus={this.state.navMenus}></DlMenu>
            </div>
          </Sider>
          <Layout className="layou_container">
            <Header>
              <div className="header_title">
                {/* <MsgList className="userTitle"></MsgList> */}
                {/* <Lock className="userTitle"></Lock> */}
                <Logout className="userTitle"></Logout>
                <Dropdown overlay={menu} placement="bottomLeft">
                  <span className="userTitle">
                    <Icon type="user" />
                    &nbsp; {userName}
                  </span>
                </Dropdown>
              </div>
              <Notice></Notice>
            </Header>
            <Content>
              <div className="ContentMain">{this.props.children}</div>
              {/* <div className="Footer_content">
                <img src={codeImg}></img>
                <a
                  href={
                    "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102001167"
                  }
                  target="_blank"
                >
                  津公网安备12010102001167号
                </a>
                <a
                  href={"https://beian.miit.gov.cn/#/Integrated/index"}
                  target="_blank"
                >
                  津ICP备2023004811号-7
                </a>
              </div> */}
            </Content>
          </Layout>
        </Layout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/layout/indexPage.js